import { convertUtcToIST, getDateFormat } from "../../Config/functions";
import { DateTime } from "luxon";

export const MagpieEntryInformation = ({ createdAt, updatedAt }: any) => {
  
  const convertToIST = (utcTimestamp: any) => {
    const dateTimeIST = DateTime.fromISO(utcTimestamp, { zone: "utc" })
      .setZone("Asia/Kolkata")
      .toFormat("yyyy-MM-dd hh:mm a");
    const [date, hour, ampm] = dateTimeIST.split(" ");
    return [date, `${hour} ${ampm}`];
  };

  return (
    <div className="col-sm-6 mt-5">
      <h4>Magpie Entry Date Time</h4>
      <table className="table table-striped border-0 mt-4">
        <tbody>
          <tr>
            <th scope="row">Entry Date:</th>
            <td>
              {createdAt
                ? ` ${getDateFormat(convertToIST(createdAt)[0])}/${
                    convertToIST(createdAt)[1]
                  }`
                : "NA"}
            </td>
          </tr>
          <tr>
            <th scope="row">Updated Date :</th>
            <td>
              {createdAt
                ? ` ${getDateFormat(convertToIST(updatedAt)[0])}/${
                    convertToIST(updatedAt)[1]
                  } `
                : "NA"}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
